import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { AppState } from 'services/types';
import {
    TimesheetHolidayDate,
    TimesheetHolidayName
} from 'services/timesheetHolidays/types';
import { EntityId } from 'services/entities/types';
import { makeSelectTimesheetHolidayName } from './selectors';

export interface OwnProps {
    timesheetDate: TimesheetHolidayDate;
    timesheetEntityId: EntityId;
}

interface ConnectedProps {
    timesheetHolidayName?: TimesheetHolidayName;
}

export type Props = OwnProps & ConnectedProps;

export class TimesheetHolidayNameComponent extends React.PureComponent<Props> {
    render(): TimesheetHolidayName | null {
        const { timesheetHolidayName } = this.props;

        if (timesheetHolidayName) {
            return timesheetHolidayName;
        }

        return null;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    timesheetHolidayName: makeSelectTimesheetHolidayName()
});

export default connect(mapStateToProps)(TimesheetHolidayNameComponent);
